export const barcodeTagList = [
  {id: "ITEM_ID", name: "Produkto kodas", defaultText: "1ANT00001"},
  {
    id: "LABEL_ID",
    name: "Etiketės skaitliuko reikšmė",
    defaultText: "4000001",
  },
  {id: "PROD_ID", name: "Gamybos dokumento ID", defaultText: "MI0369462"},
  {id: "PROD_SHIFT", name: "Pamainos numeris", defaultText: "1"},
  {id: "PROD_BRIGADE", name: "Brigados numeris", defaultText: "99"},
  {
    id: "DATESTAMP",
    name: "Data formatu YYWW (YY - metų paskutiniai du skaičiai, WW - metų savaitė)",
    defaultText: "2214",
  },
  {
    id: "SSCC",
    name: "SSCC barkodas (00)",
    defaultText: "(00)373116407580001772",
  },
  {id: "AI_01", name: "Prekės kodas (01)", defaultText: "(01)50214649531955"},
  {id: "AI_02", name: "Prekių kodas (02)", defaultText: "(02)50214649531955"},
  {id: "AI_11", name: "Gamybos data (11)", defaultText: "(11)220413"},
  {id: "AI_13", name: "Pakavimo data (13)", defaultText: "(13)220413"},
  {id: "AI_30", name: "Kiekis (30)", defaultText: "(30)0192"},
  {id: "AI_37", name: "Kiekis (37)", defaultText: "(37)0192"},
  {
    id: "AI_240",
    name: "IKEA prekės kodas (240)",
    defaultText: "(240)1020920211731",
  },
  {
    id: "AI_01_11",
    name: "Prekės kodas + Gamybos data",
    defaultText: "(01)5021464953195(11)220413",
  },
  {
    id: "AI_01_13",
    name: "Prekės kodas + Pakavimo data",
    defaultText: "(01)5021464953195(11)220413",
  },
  {
    id: "AI_02_11_30",
    name: "Prekės kodas + Gamybos data + kiekis (30)",
    defaultText: "(02)5021464953195(11)220413(30)120",
  },
  {
    id: "AI_02_11_37",
    name: "Prekės kodas + Gamybos data + kiekis (37)",
    defaultText: "(02)5021464953195(11)220413(37)120",
  },
  {
    id: "AI_02_13_30",
    name: "Prekės kodas + Pakavimo data + kiekis (30)",
    defaultText: "(02)5021464953195(11)220413(30)120",
  },
  {
    id: "AI_02_13_37",
    name: "Prekės kodas + Pakavimo data + kiekis (37)",
    defaultText: "(02)5021464953195(11)220413(37)120",
  },
  {
    id: "AI_240_11",
    name: "IKEA produktas + Gamybos data",
    defaultText: "(240)1020920211731(11)220413",
  },
  {
    id: "AI_240_13",
    name: "IKEA produktas + Pakavimo data",
    defaultText: "(240)1020920211731(11)220413",
  },
  {
    id: "AI_240_13_30",
    name: "IKEA produktas + Pakavimo data + kiekis (30)",
    defaultText: "(240)1020920211731(11)220413(30)192",
  },
  {
    id: "AI_240_13_37",
    name: "IKEA produktas + Pakavimo data + kiekis (37)",
    defaultText: "(240)1020920211731(11)220413(37)192",
  },
  {id: "AI_91", name: "Data formatu YYWW (91)", defaultText: "(91)2214"},
  {
    id: "AI_240_30",
    name: "Ikea barkodas suformuotas iš etiketės antraštės numerio, tiekėjo kodo ir kiekio (30)",
    defaultText: "(240)1020920211731(30)120",
  },
  {
    id: "AI_240_37",
    name: "Ikea barkodas suformuotas iš etiketės antraštės numerio, tiekėjo kodo ir kiekio (37)",
    defaultText: "(240)1020920211731(37)120",
  },
];

export const labelSizes = [
  {id: 0, name: "A6", width: 105, height: 148},
  {id: 3, name: "80x120", width: 80, height: 120},
  {id: 1, name: "105x57", width: 105, height: 57},
  {id: 2, name: "200x100", width: 200, height: 100},
  {id: 4, name: "105x250", width: 105, height: 250}
];

export const dpiValues = [
  {
    dpi: 72,
  },
  {
    dpi: 96,
  },
  {
    dpi: 200,
  },
  {
    dpi: 300,
  },
];

export const stringTagList = [
  {id: "ITEM_ID", name: "Prekės ID", defaultText: "1ANT00001"},
  {id: "EAN", name: "EAN kodas", defaultText: "5021464953195"},
  {id: "PROD_DATE_YYMMDD", name: "Gamybos data formatu YYMMDD", defaultText: "220413"},
  {id: "PROD_DATE_DDMMYY", name: "Gamybos data formatu DDMMYY", defaultText: "130422"},
  {id: "PROD_DATE_MMDDYY", name: "Gamybos data formatu MMDDYY", defaultText: "042213"},
  {id: "BEST_BEFORE_DATE_YYMMDD", name: "Galiojimo data formatu YYMMDD", defaultText: "220413"},
  {id: "BEST_BEFORE_DATE_DDMMYY", name: "Galiojimo data formatu DDMMYY", defaultText: "130422"},
  {id: "BEST_BEFORE_DATE_MMDDYY", name: "Galiojimo data formatu MMDDYY", defaultText: "042213"},
  {id: "ITEM_NAME", name: "Prekės pavadinimas", defaultText: "Čiuž.aps.Skydda Latt 90x200"},
  {id: "SERIAL_ID", name: "Prekės serijos ID", defaultText: "Ser00001"},
  {id: "CLIENT", name: "Kliento kodas", defaultText: "LV90011665783"},
  {id: "CLIENT_NAME", name: "Kliento pavadinimas", defaultText: "IKEA Supply AG"},
  {id: "DELIVERY_ADDRESS", name: "Pristatymo adresas", defaultText: "Mezaizveji Dreilini Stopini novads, Riga, LATVIA"},
  {id: "DOCUMENT_ID", name: "Dokumento ID", defaultText: "S0068677"},
  {id: "QTY", name: "Kiekis", defaultText: "96"},
  {id: "UNIT_ID", name: "Mato vienetas", defaultText: "vnt"},
  {id: "EMPL_ID", name: "Darbuotojo ID", defaultText: "P9999"},
  {id: "SUPPLIER", name: "Tiekėjo kodas", defaultText: "11731"},
  {id: "SSCC_SUPPLIER", name: "SSCC Tiekėjo kodas", defaultText: "3731164075"},
  {id: "SSCC_START", name: "SSCC Pradžia", defaultText: "0037"},
  {id: "DATESTAMP", name: "Data formatu YYWW (YY - metų paskutiniai du skaičiai, WW - metų savaitė)", defaultText: "2214"},
  {id: "WEIGHT", name: "Svoris", defaultText: "256"},
  {id: "GROSS_WEIGHT", name: "Gross svoris", defaultText: "200"},
  {id: "NET_WEIGHT", name: "Net svoris", defaultText: "150"},
  {id: "TARE_WEIGHT", name: "Tare svoris", defaultText: "50"},
  {id: "CU_NUMBER", name: "Lipduko numeris", defaultText: "0.5"},
  {id: "DATE_FORMAT", name: "Data formatu", defaultText: "YYYY-MM-DD"},
  {id: "PROD_DATE", name: "Gamybos data formatu", defaultText: "2022-04-13"},
  {id: "BEST_VALID_TERM_ID", name: "Geriau iki data", defaultText: "2022-04-13"},
  {id: "VALID_TERM_ID", name: "Galiojimo data", defaultText: "2022-04-13"},
  {id: "LABEL_ID", name: "Etiketės skaitliuko reikšmė", defaultText: "4000001"},
  {id: "PROD_ID", name: "Gamybos dokumento ID", defaultText: "MI0369462"},
  {id: "PROD_SHIFT", name: "Pamainos numeris", defaultText: "1"},
  {id: "PROD_BRIGADE", name: "Brigados numeris", defaultText: "99"},
  {id: "PACK_WIDTH", name: "Pakuotės plotis", defaultText: "150"},
  {id: "PACK_LENGTH", name: "Pakuotės ilgis", defaultText: "170"},
  {id: "PACK_WEIGHT_LOAD", name: "Pakuotės apkrovos svoris", defaultText: "120"},
  {id: "DATE", name: "Data formatu (YYYY-MM-DD)", defaultText: "2022-04-12"},
  {id: "ARTICLE_NR", name: "Ikea etiketės antraštės numeris(Ikea formatu išorinis prekės kodas)", defaultText: "102.092.02"},
  {id: "SSCC", name: "SSCC barkodas (00)", defaultText: "(00)373116407580001772"},
  {id: "AI_01", name: "Prekės kodas (01)", defaultText: "(01)5021464953195"},
  {id: "AI_02", name: "Prekių kodas (02)", defaultText: "(02)5021464953195"},
  {id: "AI_10", name: "Partijos nr. (10)", defaultText: "(10)A12345"},
  {id: "AI_11", name: "Gamybos data (11)", defaultText: "(11)220413"},
  {id: "AI_13", name: "Pakavimo data (13)", defaultText: "(11)220413"},
  {id: "AI_30", name: "Kiekis (30)", defaultText: "(30)192"},
  {id: "AI_37", name: "Kiekis (37)", defaultText: "(37)192"},
  {id: "AI_01_10", name: "Prekės kodas + Partija", defaultText: "(01)5021464953195(10)A12345"},
  {id: "AI_01_11", name: "Prekės kodas + Gamybos data", defaultText: "(01)5021464953195(11)220413"},
  {id: "AI_01_13", name: "Prekės kodas + Pakavimo data", defaultText: "(01)5021464953195(11)220413"},
  {id: "AI_02_10_30", name: "Prekės kodas + Partija + kiekis(30)", defaultText: "(02)5021464953195(10)A12345(30)120"},
  {id: "AI_02_10_37", name: "Prekės kodas + Partija + kiekis (37)", defaultText: "(02)5021464953195(10)A12345(37)120"},
  {id: "AI_02_11_30", name: "Prekės kodas + Gamybos data + kiekis (30)", defaultText: "(02)5021464953195(11)220413(30)120"},
  {id: "AI_02_11_37", name: "Prekės kodas + Gamybos data + kiekis (37)", defaultText: "(02)5021464953195(11)220413(37)120"},
  {id: "AI_02_13_30", name: "Prekės kodas + Pakavimo data + kiekis (30)", defaultText: "(02)5021464953195(11)220413(30)120"},
  {id: "AI_02_13_37", name: "Prekės kodas + Pakavimo data + kiekis (37)", defaultText: "(02)5021464953195(11)220413(37)120"},
  {id: "AI_240_11", name: "IKEA produktas + Gamybos data", defaultText: "(240)1020920211731(11)220413"},
  {id: "AI_240_13", name: "IKEA produktas + Pakavimo data", defaultText: "(240)1020920211731(11)220413"},
  {id: "AI_240_13_30", name: "IKEA produktas + Pakavimo data + kiekis (30)", defaultText: "(240)1020920211731(11)220413(30)192"},
  {id: "AI_240_13_37", name: "IKEA produktas + Pakavimo data + kiekis (37)", defaultText: "(240)1020920211731(11)220413(37)192"},
  {id: "AI_91", name: "Data formatu YYWW (YY - metų paskutiniai du skaičiai, WW - metų savaitė)", defaultText: "(91)2214"},
  {id: "AI_240_30", name: "Ikea barkodas suformuotas iš etiketės antraštės numerio, tiekėjo kodo ir kiekio (30)", defaultText: "(240)1020920211731(30)120"},
  {id: "AI_240_37", name: "Ikea barkodas suformuotas iš etiketės antraštės numerio, tiekėjo kodo ir kiekio (37)", defaultText: "(240)1020920211731(37)120"},
];
